let isDocEditorMounted = false;
let listeners = [];

const docEditorStore = {
  getState() {
    return isDocEditorMounted;
  },

  setState(value) {
    isDocEditorMounted = value;
    listeners.forEach(listener => listener());
  },

  subscribe(listener) {
    listeners.push(listener);
    return () => {
      listeners = listeners.filter(l => l !== listener);
    };
  },
};

export default docEditorStore;
